import { Modal, Box, Typography, Button, Stack, CircularProgress } from '@mui/material';
import { ConfirmDeleteModalProps } from '~/shared/types/types';

export const ConfirmDeleteModal = ({
    open,
    onClose,
    onConfirm,
    header = 'Удалить объект?',
    isLoading = false,
    loading = false,
}: ConfirmDeleteModalProps) => {
    const effectiveLoading = Boolean(isLoading || loading);
    return (
        <Modal open={open} onClose={effectiveLoading ? undefined : onClose}>
            <Box sx={{
                position: 'absolute' as const,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
            }}>
                <Typography variant="h6" mb={2}>
                    {header}
                </Typography>
                <Typography variant="body2" mb={3}>
                    Это действие необратимо. Вы уверены?
                </Typography>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button onClick={onClose} variant="outlined" color="primary" disabled={effectiveLoading}>
                        Отмена
                    </Button>
                    <Button onClick={onConfirm} variant="contained" color="error" disabled={effectiveLoading}>
                        {effectiveLoading ? <CircularProgress size={18} sx={{ mr: 1, color: 'white' }} /> : null}
                        {effectiveLoading ? 'Удаление...' : 'Удалить'}
                    </Button>
                </Stack>
            </Box>
        </Modal>
    );
};
